/*
https://closure-compiler.appspot.com/home
https://obfuscator.io/

・命名ルール：
　アプリ共通：c(common), アプリ個別・モジュール共通：i(individual), アプリ個別・モジュール個別：p(paticular) or _(underscore)

・map のメリットは、処理結果を即配列に代入できること、記述が簡素化されること

・map はスキップされるため await を必要に応じて使用する

・map の引数関数を async する場合は、await Promise.all で map を括る必要がある
  await Promise.all(_ld_iss.map(async _d_is => {
    return await _o_fnc();
  }));

・promise の結果は、スコープの広い変数を用いて共有する

・pck の初期化 は -1 で行う

・this.$osr は処理が循環しないよう、データの流れに注意する（幹から枝へ処理する）、原則として fld の更新のみに使用し、load の代替としては使用しない

・setState を同時並行で実施した場合、処理が適切に行われない場合がある

・アップグレード時の対応事項


・コンポーネントの作り方
　・state で 仮のデータを作る
　・コンポーネントの表示機能を作成し仮のデータを表示する（select）
　・仮のデータを変更可能とする（update）
　・仮のデータを追加登録可能とする（insert）
　・仮のデータを削除可能とする（delete）

・immer は本体の差し替えには対応していないもよう
・immer による代入と、通常の代入は混在できないもよう
・配列コンポーネントにおいて、変更前後で key が異なる場合、コンポーネントが正しく入れ替わらない事になる

・iphone では margin / padding を top/bottom/left/right の別に指定する必要がある
・要素には、必ず、階層ごとにユニークな key を設定すること

・function や state を介したコンポーネントは、state の変更や共有が正しく行われないことがある ＞ RN の伝搬ルールを理解する必要がある

・stl は別に分ける必要がありそう

・シンプルなプログラム構造とする
・複数関数をまたいだ listener は実行されない模様、component から直接関数を呼び出す必要がある
・値は、this.state.am1a1020 で参照、引数は構造体となっており直接値を参照できない
・複数のモーダルを切り替えて画面遷移させることはできない模様、その場合、コンポーネントを分けるか、overlay か、ほかのダイアログの使用を検討か？
・起動直後に落ちる場合は、import に正しく名前が設定されているか、import されてない要素が render で使われていないか、無効なコンポートがApp.jsでインポートされていないか、c.jsx に無効な関数が含まれていないか
・alert は 2 以上同時に表示されることはないらしい
・encountered two childre with the same key は、複数のコンポーネントで class 名が重複している場合に発生？
・javascript
  0 == false, 1 == true, _l.update = _l.push, _d.update = _d.assign
・動かない理由は、関数名が誤っている、let/const がついていない
・Value for title can not be cast from double to string
　→ title の "" を '' に変える
・callable function の中で class の this は機能しない
・for 文の後の処理は平行して実行される　→ myCM_for_each2 を使用
・Possible unhandled promise rejection
　→ then の後は同じ型のデータを返す catch を必ずつける
・function 中の this において state は無効、全て _o_this として引用
・this.state において state の付け忘れがないかを確認
×setState は 変数ベースでは機能せず、必ず、{} で変更対象の状態変数を具体的に記載する必要がある模様
・setState を用いた際は、await したいと状態の同期がとれない場合がある
・react native や 関連するモジュールの仕様が変更され、従来の設定では正しく動作しなくなる場合があることに注意
・状態変数がコンポーネントの引数に含まれていない場合、状態変化は伝搬しない模様

// common program として実現したいこと
* 選択されたメニューをハイライト表示する？
* 画面を遷移した際に、pageName と pageKey を push & delete する　－＞ javascript の push / pop を使えばよい
済　* 画面を遷移した際に、状態変数を全てクリアする


expo upgrade

expo install @react-native-community/async-storage
expo install @react-navigation/native
expo install @react-navigation/stack
expo install immer
expo install expo-av
expo install expo-constants
expo install expo-document-picker
expo install expo-file-system
expo install expo-image-picker
expo install expo-intent-launcher
expo install expo-permissions
expo install expo-sharing
expo install expo-updates
expo install react-native-calendars
expo install react-native-gesture-handler
expo install react-native-mime-types
expo install react-native-paper
expo install react-native-screens
expo install react-native-step-indicator
expo install react-native-ticker
expo install react-native-unimodules
expo install react-native-vector-icons


//expo install react-navigation
//expo install react-navigation-stack
//expo install modal-enhanced-react-native-web
//expo install react-native-icon-badge
//expo install react-native-modal
//expo install react-native-picker-select
*/


// for myRN
import { 
  Alert,
  Dimensions,
  Keyboard,
  Linking, 
  Platform, 
  StatusBar,
//    StyleSheet,
} from "react-native"; 

// for myLS
import AsyncStorage from '@react-native-community/async-storage'

// for expo
import Constants from 'expo-constants';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';
import * as ImagePicker from 'expo-image-picker';
import * as IntentLauncher from 'expo-intent-launcher';
import * as Permissions from 'expo-permissions';
import * as Sharing from 'expo-sharing';
import * as Updates from 'expo-updates';

/*
import {
  StackActions,
  NavigationActions, 
} from 'react-navigation';
*/

import {
  CommonActions,
} from '@react-navigation/native';

/*
import {
    Constants,
    //DocumentPicker,
    Permissions,
    ImagePicker,
    Updates,
    FileSystem,
} from 'react-native-unimodules' // for react-native
*/

import * as mime from 'react-native-mime-types'; // for mimeType

import KeyEvent from 'react-native-keyevent'; // expo ng

import { bf } from './bf';
import { ic } from './ic';

import { iv } from './iv';

export class cf { // common function

  //////////////////////////////////////////////////////////////////////// short cut
    
  static s = cf.myRN_ldr_show;

  static h = cf.myRN_ldr_hide;

  //////////////////////////////////////////////////////////////////////// for callback

  static myCB_call_eml(p_eml, p_sbj, p_msg){ // 汎用メール送信
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'send', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml, sbj:p_sbj, msg:p_msg},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss,
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_nmb(p_eml){ // 指定したメールアドレスへの確認番号の送信
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'eml', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_cnf(p_eml, p_nmb){ // 確認番号の確認
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'cnf', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml, nmb:p_nmb},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_dwl = (pd={
    elm: '', 
    tgt: '',
  }) => new Promise( _o_end1 =>{
    let _ld_valss = [
      {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'dwl', ctr:'', prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
        tgt:pd.tgt,
      }},
    ];
    cf.myCR_xhr({
      mode: 'POST',
      url: ic.g_url1,
      ld_valss: _ld_valss
    })
    .then((_a_res) => {
      if (bf.f(_a_res)) {
        cf.myRN_open_url('{}/{}'.f(ic.g_url2, _a_res.file))
        .then( () => {
          _o_end1(_a_res);
        });
      }
      else {
        _o_end1(null);
      }
    });
  });

/*
  static myCB_call_iud = (p_ctr, p_elm, pd_vals, p_cnd='', p_qry='', pl_qrys=[]) => new Promise( async _o_end1 => {
    if (p_ctr == 'qrys') {
      for await (let [_idx, _qry] of bf.e(pl_qrys)) {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:'qry', prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
            val:pd_vals,
            cnd:p_cnd,
            qry:_qry,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        });
      }
      _o_end1();
    }
    else if (p_ctr == 'ins'){
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:p_ctr, prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
          val:pd_vals,
          cnd:p_cnd,
          qry:p_qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        global.c?.setState({ // ins 時は自動的に d_oos に ins値が設定される
          sgcd_pageCmns?: bf.p(global.c?.state.sgcd_pageCmns?, _next => {
            _next['d_{}s'.f(p_elm)] = _a_res;
          }),
        }, () => {
          _o_end1(_a_res);
        });
      });
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:p_ctr, prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
          val:pd_vals,
          cnd:p_cnd,
          qry:p_qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    };
  });
*/
  static myCB_call_iud = (pd={
    ctr: '', 
    elm: '', 
    d_vals: {}, 
    cnd: '', 
    qry: '', 
    l_qrys: []
  }) => new Promise( async _o_end1 => {
//bf.l('319: {}, {}'.f(pd.elm, pd.cnd));
    if (pd.ctr == 'qrys') {
      for await (let [_idx, _qry] of bf.e(pd.l_qrys)) {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:'qry', prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
            val:pd.d_vals,
            cnd:pd.cnd,
            qry:_qry,
          }},
        ];
        await cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        });
      }
      _o_end1();
    }
    else if (pd.ctr == 'ins'){
/*
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          val:pd.d_vals,
          cnd:pd.cnd,
          qry:pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
*/
/*
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          val:pd.d_vals,
          cnd:pd.cnd,
          qry:pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then( async _a_res => {
        if (pd.cnd) { // 強制 ins
          let _n_cnt = 0;
          let _n_cntMax = 10;
          while ( _n_cnt < _n_cntMax) {
            await cf.myCB_call_slc({
              ctr: 'nlm', 
              elm: pd.elm, 
              n_dms: 2, 
              cnd: pd.cnd,
            })
            .then( async _d_rs => {
              if (bf.f(_d_rs)) { // 反映に成功している場合
                _o_end1(_d_rs);
              }
              else { // 反映に失敗している場合
                _n_cnt + 1;
                await bf.myCM_wait(1*_n_cnt);
                await cf.myCB_call_iud({
                  ctr: 'ins', 
                  elm: pd.elm, 
                  d_vals: pd.d_vals,
                })
              }
            });
          };
          alert('387: データの反映を確認できませんでした\n {}'.f(pd.elm))
          _o_end1(null);
        }
        else {
          _o_end1(_a_res);
        }
      });
*/
      if (pd.cnd) { // 強制 ins
//bf.l('405: {}, {}, {}'.f(pd.elm, pd.n_cnt, pd.cnd));
        if ((pd.n_cnt ?? 0) > 10) {
          alert('387: データの反映を確認できませんでした\n {}'.f(pd.elm))
          _o_end1(null);
        }
        else {
//bf.l('409: {}, {}, {}'.f(pd.elm, pd.n_cnt, pd.cnd));
          cf.myCB_call_slc({ // 事前確認
            ctr: 'nlm', 
            elm: pd.elm, 
            n_dms: 2, 
            cnd: pd.cnd,
          })
          .then( async _d_rs => {
//bf.l('417: {}, {}, {}'.f(pd.elm, pd.n_cnt, _d_rs));
            if (bf.f(_d_rs)) { // ins されてる場合
//bf.l('419: {}, {}, {}'.f(pd.elm, pd.n_cnt, _d_rs));
              _o_end1(_d_rs);
            }
            else { // ins されてない場合
//bf.l('423: {}, {}, {}'.f(pd.elm, pd.n_cnt, _d_rs));
              cf.myCB_call_iud({
                ctr: 'ins', 
                elm: pd.elm, 
                d_vals: pd.d_vals,
              })
              .then(() => {
//bf.l('430: {}, {}, {}'.f(pd.elm, pd.n_cnt, pd.cnd));
                cf.myCB_call_iud({
                  ctr: 'ins', 
                  elm: pd.elm, 
                  d_vals: pd.d_vals,
                  cnd: pd.cnd,
                  n_cnt: (pd.n_cnt ?? 0) + 1,
                })
                .then( _d_rs => {
//bf.l('439: {}, {}, {}'.f(pd.elm, pd.n_cnt, pd.cnd));
                  _o_end1(_d_rs);
                })
              })
            }
          });
        };
      }
      else { // 通常 ins
//bf.l('448: {}, {}, {}'.f(pd.elm, pd.d_vals, pd.cnd));
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
            val:pd.d_vals,
            cnd:pd.cnd,
            qry:pd.qry,
          }},
        ];
        await cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then( async _a_res => {
//bf.l('462: {}, {}, {}'.f(pd.elm, pd.d_vals, pd.cnd));
          _o_end1(_a_res);
        });
      }
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          val:pd.d_vals,
          cnd:pd.cnd,
          qry:pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    };
  });

  static myCB_call_slc = (pd={
    ctr: 'nlm/qry', 
    elm: '', 
    n_dms: 0, 
    cnd: '', 
    qry: '', 
    do_rfrs: null, 
    ddo_rfrss: null, 
    dld_pcksss: null, 
    d_cashs: null,
    ld_sortss: [{fld:'key', dtn:'asc'}],
  }) => new Promise( _o_end1 => {
//bf.l('380:{}, {}'.f(pd.elm, pd.cnd))
//bf.l('380:{}, {}'.f(pd.ld_sortss))
//if (pd.elm=='it30') bf.l('396: {}'.f(pd.ld_sortss));
    if (
      pd.d_cashs && 
      pd.d_cashs[pd.cnd]
    ) { // キャッシュが指定されており、キャッシュが存在する場合
      _o_end1(pd.d_cashs[pd.cnd])
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'slc', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          dms: pd.n_dms,
          cnd: pd.cnd,
          qry: pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then( async _a_res => {
        //
        if (pd.n_dms == 3) {
          //
          let _l = [];
          //
          let _dd_cashss = {};

          if (pd.do_rfrs){ // rfrs が定義されている場合 // 廃止予定
            for await (let [_elm, _cnd] of bf.e(pd.do_rfrs)) {
              _dd_cashss[_elm] = {};
            }
          };
          if (pd.ddo_rfrss){ // rfrs が定義されている場合
            Object.keys(pd.ddo_rfrss)
            .map( _als => {
              _dd_cashss[pd.ddo_rfrss[_als].elm] = {};
            });
          };
          //
          for await (let [_idx, _d_vals] of bf.e(_a_res)) {
            //
            let _d_vals2 = {};
            //
            if (bf.f(pd.do_rfrs)){ // rfrs が定義されている場合 // 廃止予定
              for await (let [_elm, _o_cnd] of bf.e(pd.do_rfrs)) {
                let _cnd = _o_cnd(_d_vals);
//bf.l('419:{}, {}'.f(_elm, _cnd))
                if (bf.f(_cnd)) {
                  await cf.myCB_call_slc({
                    ctr: 'nlm', 
                    elm: _elm, 
                    n_dms: 2, 
                    cnd: _cnd,
                    d_cashs: _dd_cashss[_elm],
                  })
                  .then( _d_vals3 => {
                    if (bf.f(_d_vals3)) { // データが存在した場合
                      _d_vals3['{}_key'.f(_elm)]=_d_vals3._KEY;
                      _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals3);
                    };
                  });
                };
              };
            };
//bf.l('461: here')
            //
            if (bf.f(pd.ddo_rfrss)){ // rfrs が定義されている場合
              await Promise.all(
                Object.keys(pd.ddo_rfrss)
                .map( _als => new Promise( _o_end2 => {
                  let _elm = pd.ddo_rfrss[_als].elm;
                  let _cnd = pd.ddo_rfrss[_als].o_cnd(_d_vals);
//bf.l('469: {}, {}, {}'.f(_als, _elm, _cnd))
                  cf.myCB_call_slc({
                    ctr: 'nlm', 
                    elm: _elm, 
                    n_dms: 2, 
                    cnd: _cnd,
                    d_cashs: _dd_cashss[_elm],
                  })
                  .then( _d_vals3 => {
                    if (bf.f(_d_vals3)) { // データが存在した場合
                      _d_vals3['{}_key'.f(_elm)]=_d_vals3._KEY;
                      _d_vals2[_als] = _d_vals3;
                      _o_end2();
                    }
                    else {
                      _o_end2();
                    };
                  });
                }))
              );
            };
            //
//bf.l('489: here')
            _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals);
            //
            if (bf.f(pd.dld_pcksss)){ // pcks が定義されている場合
              for await (let [_fld, _ld_pckss] of bf.e(pd.dld_pcksss)) { // _d_defs.pcks は通常の pcks と同形式であること {key:{key:'', pfx:''}}
                if (_d_vals2[_fld] && bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]})) {
                  _d_vals2[_fld] = bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]}).pfx;
                }
              };
            };
            //
            _l.push(_d_vals2)
          };
          _a_res = _l;
//console.log('377:{}'.f(_a_res));
//for (let [_idx, _val] of bf.e(_a_res)) {
//  console.log('379:{}'.f(_val.it10i110));
//};
          let _a_res2 = bf.myCM_sort({
            ld_itemss: _a_res, 
            ld_sortss: pd.ld_sortss,
          });
//console.log('382:{}'.f(_a_res));
//for (let [_idx, _val] of bf.e(_a_res2)) {
//  console.log('387:{}'.f(_val.it10i110));
//};
          //
          if (pd.d_cashs){ // キャッシュが指定されている場合
//            pd.d_cashs[pd.cnd] = _a_res;
            pd.d_cashs[pd.cnd] = _a_res;
          }
          _o_end1(_a_res2);
        }
        else {
          if (pd.d_cashs){ // キャッシュが指定されている場合
            pd.d_cashs[pd.cnd] = _a_res;
          }
          _o_end1(_a_res);
        };
      })
      .catch( _err => {
        let _n_wait = (pd.n_wait) ? pd.n_wait : 1;
        bf.myCM_wait(_n_wait)
        .then(() => {
          cf.myCB_call_slc(bf.p(pd, _next => {
            _next.n_wait = _n_wait * 2;
          }))
          .then( _a_res => {
            _o_end1(_a_res);
          });
        })
      });
    }
  });

/*
static myCB_callQrys = (pd={
  l_tgts: [],
  dd_qryss: {
    tgt: {
      l_trgs:[],
      lo_qrys:[],
    },
  },
  d_vals: {
  },
}) => new Promise( _o_end1 => {
  Promise.all(
    pd.l_tgts.map( async _tgt => {
      if (pd.dd_qryss[_tgt]) {
        await Promise.all(
          pd.dd_qryss[_tgt].lo_qrys
          .map( async _o_qry => {
            let _qry = _o_qry(pd.d_vals);
    bf.l('562: {}'.f(_qry));
    //        if (bf.f(_qry)) {
            if (false) {
              await cf.myCB_call_iud({
                ctr: 'qrys',
                elm: '----',
                l_qrys: [_qry], 
              });
            };
            await Promise.all(
              Object.keys(pd.dd_qryss)
              .map( async _tgt2 => {
                if (bf.i(_tgt, pd.dd_qryss[_tgt2].l_trgs)) {
                  await cf.myCB_callQrys({
                    l_tgts: [_tgt2],
                    dd_qryss: pd.dd_qryss,
                    d_vals: pd.d_vals,
                  })
                }
              })
            )
          })
        );
      };
    })
  )
  .then(() => {
    _o_end1();
  });
});
*/
/*
static myCB_callQrys = (pd={
  l_tgts: [],
  dd_qryss: {
    tgt: {
      pfx: '',
      l_trgs:[],
      lo_qrys:[],
    },
  },
  d_vals: {
  },
}) => new Promise( _o_end1 => {
  Promise.all(
    pd.l_tgts.map( async _tgt => {
      if (pd.dd_qryss[_tgt]) {
        for await (let [_idx, _o_qry] of bf.e(pd.dd_qryss[_tgt].lo_qrys)) {
          let _qry = _o_qry(pd.d_vals);
          if (bf.f(_qry)) {
//bf.l('613: {}, {}'.f(pd.dd_qryss[_tgt].pfx, _qry))
            await cf.myCB_call_iud({
              ctr: 'qrys',
              elm: '----',
              l_qrys: [_qry], 
            })
          };
        }
      };
      await Promise.all(
        Object.keys(pd.dd_qryss)
        .map( async _tgt2 => {
          if (bf.i(_tgt, pd.dd_qryss[_tgt2].l_trgs)) {
            await cf.myCB_callQrys({
              l_tgts: [_tgt2],
              dd_qryss: pd.dd_qryss,
              d_vals: pd.d_vals,
            })
          }
        })
      )
    })
  )
  .then(() => {
    _o_end1();
  });
});
*/
static myCB_callQrys = (pd={
  l_tgts: [],
  dd_qryss: {
    tgt: {
      pfx: '',
      l_trgs:[],
      lo_qrys:[],
    },
  },
  d_vals: {
  },
}) => new Promise( async _o_end1 => {
  for await (let [_idx, _tgt] of bf.e(pd.l_tgts)) {
    if (pd.dd_qryss[_tgt]) {
      for await (let [_idx, _o_qry] of bf.e(pd.dd_qryss[_tgt].lo_qrys)) {
        let _qry = _o_qry(pd.d_vals);
        if (bf.f(_qry)) {
//bf.l('613: {}, {}'.f(pd.dd_qryss[_tgt].pfx, _qry))
          await cf.myCB_call_iud({
            ctr: 'qrys',
            elm: '----',
            l_qrys: [_qry], 
          })
        };
      }
    };
    for await (let [_idx2, _tgt2] of bf.e(Object.keys(pd.dd_qryss))) {
      if (bf.i(_tgt, pd.dd_qryss[_tgt2].l_trgs)) {
        await cf.myCB_callQrys({
          l_tgts: [_tgt2],
          dd_qryss: pd.dd_qryss,
          d_vals: pd.d_vals,
        })
      }
    };
  }
  _o_end1();
});

//  static myCB_set_clds = (p_state, pd) => new Promise( _o_end1 => {
  static myCB_set_clds = (pd={
  }) => new Promise( _o_end1 => {
//bf.l('499:{}, {}'.f(pd.do_rfrs, pd.ld_sortss))
    if (pd.b_withCnd == true && bf.f(pd.cnd) == false) { // pd.cnd が空白の場合は clds を取得しない
/*
      let _l = [];
      global.c?.setState({
        [pd.state]: _l,
      }, ()=>{
        _o_end1(_l);
      });
*/
      let _r = []; // list only
      global.c?.setState({
        [pd.state]: _r,
      }, ()=>{
        _o_end1(_r);
      });
    }
    else {
      cf.myCB_call_slc(pd)
      .then( async _ld_iss => { // list only
        global.c?.setState({
          [pd.state]: _ld_iss,
        }, ()=>{
          _o_end1(_ld_iss);
        });
      });
    };
  });

//  static myCB_set_items = (p_state, pd, po_fnc) => {
  static myCB_set_items = (pd) => {
//if (pd.elm=='it30') bf.l('396: {}'.f(pd.ld_sortss));
    return new Promise( _o_end1 => {
      cf.myCB_call_slc(pd)
      .then( async _ld_itemss => {
        let _ld_valss = [];
        for await (let [_idx, _d_items] of bf.e(_ld_itemss)) {
          let _d_items2 = await pd.o_fnc(_d_items);
          _d_items2.key = _d_items._KEY;
          _d_items2.val = _d_items;
          _ld_valss.push(_d_items2);
        };

        global.c?.setState({
          [pd.state]: _ld_valss,
        }, ()=>{
          _o_end1(_ld_itemss);
        });
      })
    });
  }

  static myCB_call_rfr(pd_vals, p_elm, p_cnd='', pdd_cashss=null){ // 複数の elm/cnd に対応可能とする
    return new Promise((resolve) => {
      if (pdd_cashss && pdd_cashss[p_cnd]) { // キャッシュが指定されており、キャッシュが存在する場合
        resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
      }
      else {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'slc', ctr:'nlm', prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
            dms:2, // 2 固定
            cnd:p_cnd,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
          if (pdd_cashss){ // キャッシュが指定されている場合
            //
            pdd_cashss[p_cnd] = _a_res;
            resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
          else { // キャッシュが指定されてない場合
            resolve(bf.myCM_upd(_a_res, pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
        });
      }
    });
  };

  static myCB_call_upl(p_elm, p_fld, p_key, pd_files){
    return new Promise((resolve, reject)=>{
      if (bf.f(pd_files.uri) && pd_files.lct == 'int') { // uri が 指定されており http画像以外の場合
        //
        let _ld_valss = [];
        //
        if (!cf.myRN_chk_os('w')) { // ios/android の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(p_elm, p_key), fld:'',
              val:{mode:'open', flds:{file:p_fld}, type:'file'} // 単一のフィールドに変更する必要あり
            }},
            {key:'file', vals:{
              uri: pd_files.uri, name: pd_files.name, type: pd_files.type,
            }}
          ];
        }
        else{ // web の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(p_elm, p_key), fld:'',
              val:{mode:'open', fld:p_fld, type:'base64', base64:pd_files.uric.split(',')[1], name:pd_files.name} 
            }},
          ];
        };
        //
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
            resolve(_a_res);
        })
        .catch((_err) =>{
            reject(_err);
        }); 
          
      }
      else {
        reject('incorrect file.');
      };
    });
  };

  static myCB_call_ver(){
    return new Promise((resolve, reject)=>{
      //
      if (!bf.f(ic.g_url1)){
        resolve(null);
      };
      //
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'ver', prc:'', vwi:'', idc:'/', fld:'',
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      })
      .catch((_err) => {
        reject(_err);
      });
    });
  };

  static myCB_load_tree = (pd={
    state: '',
    d_pntItems: {}, // defined only at root
    elm: '',
    o_cnd: _d_items => {},
    l_flds: [''],
    d_cldDefs: { // same with pd
      elm: '',
      cnd: _d_items => {},
      l_flds: [],
      d_cldDefs: {},
    },
  }) => new Promise( async _o_end1 => {

    await cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: pd.elm, 
      n_dms: 3, 
      cnd: pd.o_cnd(pd.d_pntItems)
    })
    .then( async _ld_itemss => {

      let _ld_treeItemss = await Promise.all(_ld_itemss.map( async _d_items => { // map で async を使用する場合、await Promise.all で括る
        //
        let _ld_fldss = pd.l_flds.map( _fld => ({
          fld: _fld,
          ini: _d_items[_fld],
          val: _d_items[_fld],
          b_uid: false,
        }));
        //
        let _ld_cldElmss = [];
        if (bf.f(pd.d_cldDefs)) {
          await cf.myCB_load_tree(bf.p(pd.d_cldDefs, _next => {
            _next.d_pntItems = _d_items;
          }))
          .then( _res => {
            if(bf.f(_res)) {
              _ld_cldElmss = _res;
            }
          });
        };            
        //
        return { // _d_treeItems
          elm: pd.elm,
          key: _d_items._KEY,
          b_dlt: false,
          b_cls: false,
          ld_fldss: _ld_fldss,
          ld_cldElmss: _ld_cldElmss,
        };
      }));

      if (bf.f(pd.state)) {
        global.c?.setState({
          [pd.state]: _ld_treeItemss,
        }, () => {
          _o_end1(_ld_treeItemss);
        });
      }
      else {
        _o_end1(_ld_treeItemss);
      };    
    });
  });

  static myCB_ups_tree = (pd={
    elm: '', // only for identification
    pntKey: '',
    ld_elmss: [],
    o_insFlds: (_d_elms, _pntKey) => {},
    do_updFlds: {'fldName': (_d_elms, _pntKey) => {}},
    d_cldDefs: {}, // same with pd
  }) => new Promise( async _o_end1 => {
    let _pntKey = pd.pntKey || '';
    await pd.ld_elmss?.map( _d_elms => {
      if (_d_elms.b_dlt == true) { // 削除データの場合
        if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
          //// 対応事項なし
        }
        else { // 既存データの場合
          let _d = {
            ['{}cz10'.f(_d_elms.elm)] : '0', // 非表示
          };
          let _cnd = bf.q(`[_KEY]={}`.f(_d_elms.key));
          cf.myCB_call_iud({
            ctr: 'upd', 
            elm:_d_elms.elm, 
            d_vals: _d, 
            cnd: _cnd
          });
        };
      }
      else { // 削除データではない場合
        new Promise ( async _o_end3 => {
          if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
//            let _d = pd.o_insFlds(_d_elms);
            let _d = pd.o_insFlds(_d_elms, _pntKey);
//alert('630:{}, {}, {}'.f(pd.elm, _d_elms.elm, _d));
            cf.myCB_call_iud({
              ctr: 'ins', 
              elm: _d_elms.elm, 
              d_vals: _d
            })
            .then( _res => {
                _o_end3(_res._KEY);
            })
          }
          else { // 既存データの場合
            let _cnd = bf.q(`[_KEY]={}`.f(_d_elms.key));
            await _d_elms.ld_fldss.map( _d_flds => { // fld ごとにデータを更新
              if (_d_flds.b_uid == true) {
//                let _d = pd.do_updFlds[_d_flds.fld](_d_elms);
                let _d = pd.do_updFlds[_d_flds.fld](_d_elms, _pntKey);
                if (bf.f(_d)) {
//alert('641:{}, {}, {}'.f(pd.elm, _cnd, _d_flds.fld, _d));
                  cf.myCB_call_iud({
                    ctr: 'upd', 
                    elm: _d_elms.elm, 
                    d_vals: _d, 
                    cnd: _cnd
                  });
                };
              };
            })
            _o_end3(_d_elms.key);
          };
        })
        .then( async _crrKey => {
//          if (bf.f(pd.d_cldDefs)) { // 子要素が存在する場合
          if (bf.f(_d_elms.ld_cldElmss)) { // 子要素が存在する場合
//alert('647:{}, {}, {}, {}'.f(pd.elm, _pntKey, _d_elms.ld_cldElmss, pd.d_cldDefs))
            cf.myCB_ups_tree(bf.p(pd.d_cldDefs, _next => {
              _next.pntKey = _crrKey;
              _next.ld_elmss = _d_elms.ld_cldElmss;
            }));
          };
        });
      };
    });
    _o_end1();
  });

  static myCB_hlr = (pd={ // handler
    elm: '',
    mode: 'get/set/itemss/clds/ins/upd/ups',
    d_vals: {}, // ins/upd/ups
    cnd: '',
    b_clr: false, // get/set
    state: '', // items/clds
    od_setDefs: (pd_is) => {}, // set
    od_itemsDefs: (pd_is) => {}, // items
    od_upsDefs: () => {},
    b_wotDlt: false, // items
    do_rfrs: {
      fld: _d_items => o_cnd(_d_items),
    }, // items
    dld_pcksss: {
      fld: [
        {key:'', pfx:''},
      ],
    }, // items
    ld_sortss: [
      {fld:'_KEY', dtn:'asc'}
    ], // items
  }) => new Promise( _o_end1 => {

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 2, 
          cnd: pd.cnd
        })
        .then( _d_ress => {
          _o_end1(_d_ress);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: pd.elm, 
            n_dms: 2, 
            cnd: pd.cnd
          })
          .then( _d_rs => {
            _o_end2(_d_rs);
          });
        };
      })
      .then( _d_rs => {
        _d_rs = bf.f(_d_rs) ? _d_rs : {};
        global.c?.setState(
          pd.od_setDefs(_d_rs), 
          () => {
            _o_end1(_d_rs);
          }
        );
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: pd.elm, 
        n_dms: 3,
        state: pd.state, 
        cnd: pd.cnd,
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
        o_fnc: _d_items => {
          let _d_rss = pd.od_itemsDefs(_d_items);
          _d_rss.b_dlt = (pd.b_wotDlt == true && _d_items['{}cz10'.f(pd.elm)] == '0') ? true : false; // b_wotDlt == true かつ cz10 == '0' は 表示対象外
          return _d_rss;
        },
      })
      .then( _ld_rss => {
        _o_end1(_ld_rss)
      });
    }
/*
    else if (pd.mode == 'cld') {
      cf.myCB_set_clds(
        {
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 2, 
          cnd: pd.cnd || '',
          state: pd.state,
          b_withCnd: pd.b_withCnd || false, // false の場合 cnd == '' では値が検索されない
          do_rfrs: pd.do_rfrs,
          dld_pcksss: null, // pd.dld_pcksss は反映しない 区分値が置き換わるため
          ld_sortss: pd.ld_sortss,
        }
      )
      .then( _d_is => {
        _o_end1(_d_is);
      });
    }
*/
    else if (pd.mode == 'clds') {
      cf.myCB_set_clds(
        {
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 3, 
          cnd: pd.cnd || '',
          state: pd.state,
          b_withCnd: pd.b_withCnd || false, // false の場合 cnd == '' では値が検索されない
          do_rfrs: pd.do_rfrs,
          dld_pcksss: null, // pd.dld_pcksss は反映しない 区分値が置き換わるため
          ld_sortss: pd.ld_sortss,
        }
      )
      .then( (_ld_iss) => {
        _o_end1(_ld_iss);
      });
    }
    else if (pd.mode == 'file') {
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: pd.elm, 
        n_dms: 3, 
        cnd: pd.cnd,
        b_withCnd: true, // false の場合 cnd == '' では値が検索されない
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
      })
      .then( _ld_iss => {
        let _ld = bf.c(
          [pd.od_fileDefs().hdr],
          _ld_iss.map( _d_is => {
            return pd.od_fileDefs(_d_is).val
          })
        );
        let _s = _ld.join('\n');
        _o_end1(_s);
      });
    }
    else if (pd.mode == 'ins') {
      cf.myCB_call_iud({
        ctr: 'ins', 
        elm: pd.elm,
        d_vals: (pd.d_vals) ? pd.d_vals : pd.od_insDefs(), // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
      })
      .then( _d_rs => {
        _o_end1(_d_rs);
      });
    }
    else if (pd.mode == 'upd') {
      if (bf.f(pd.cnd)) {
        cf.myCB_call_iud({
          ctr: 'upd', 
          elm: pd.elm, 
          d_vals: (pd.d_vals) ? pd.d_vals : pd.od_updDefs(), // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
          cnd: pd.cnd
        })
        .then( () => {
          _o_end1();
        });
      }
      else {
        alert('891:incorrect cnd at myCB_hlr: {}'.f(pd.cnd));
      };
    }
    else if (pd.mode == 'ups') {
      if (bf.f(pd.cnd)) {
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: pd.elm, 
          d_vals: (pd.d_vals) ? pd.d_vals : pd.od_upsDefs(), 
          cnd: pd.cnd
        })
        .then( () => {
          _o_end1();
        });
      }
      else {
        alert('901:incorrect cnd at myCB_hlr: {}'.f(pd.cnd));
      };
    }
    else if (pd.mode == 'upsClds') {
      global.c?.state[pd.state].map( _d_is => { 
        pd.o_upsCldsDefs( _d_is )
        .then( _d => {
//bf.l('986:{}, {}'.f(_d.cnd, _d.d_vals))
          if (bf.f(_d.d_vals)) {
            cf.myCB_call_iud({
              ctr: 'ups', 
              elm: pd.elm, 
              d_vals: _d.d_vals, 
              cnd: _d.cnd,
            })
          };
        });
      });
      _o_end1();
    }

    else {
      alert('905:incorrect mode at myCB_hlr: {}'.f(pd.mode));
    };

  });

  ////////////////////////////////////////////////////////////////////////
  static myCR_post(p_url, pd_vals, po_fnc) {
    return fetch(p_url, {
      method: "POST", 
      body: bf.myCM_cnv('json-str', pd_vals)
    })
    .then((_res) => _res.json())
    .then((_d_ress) => po_fnc(_d_ress));
  };

  static myCR_sbm(p_url, pld_valss, po_fnc=null) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    //
    let _o_this = this;
    //
    let _body = new FormData();
    //
    this.myCM_for_each(pld_valss, function (_d_vals) {
      if (_d_vals['key'] == 'data') {
        _body.append(_d_vals['key'], JSON.stringify(_d_vals['vals']));
      }
      else {
        _body.append(_d_vals['key'], _d_vals['vals']);
      };
    });

    if (po_fnc != null) {
      return fetch(p_url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        body: _body
      })
      .then((_res) => { 
        if (_res != null) {
          return _res.json();
        }
        else {
          return 'null';
        }
      })
      .then((_d_res) => {
        po_fnc(_d_res);
      })
      .catch((_err)=>{
        //alert('{} : {}'.f(_err.message, JSON.stringify(_body)));
      });
    }
    else {
      return fetch(p_url, {
        method: 'POST',
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: _body
      })
      .catch((_err)=>{
      });
    };
  };

  static myCR_xhr(pd={
    mode:'POST',
    url:'', 
    ld_valss:[], 
  }) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    return new Promise(async (_o_end1, _o_err1) => {

      let _body = new FormData();

      if (pd.ld_valss) {
        for await (let [_idx, _d_vals] of bf.e(pd.ld_valss)) {
          if (_d_vals.key == 'data') {
            _body.append('data', bf.s(_d_vals.vals));
          };
          if (_d_vals.key == 'file') { // 1bodyに含められるfileは1つのみ
            _body.append('file', _d_vals.vals);
          };
        };
      };

//bf.l('1097:{}'.f(pd))
      let _xhr = new XMLHttpRequest();
      _xhr.open(pd.mode, pd.url, true);
      _xhr.responseType = 'json';
      _xhr.send(_body);
      _xhr.onreadystatechange = () => {
        if( _xhr.readyState === 4 && _xhr.status === 200 ) { // _xhr.status が 0 の場合は、nginx の conf.d を確認
          _o_end1(_xhr.response);
        }
      };
      _xhr.onerror = () => {
        _o_err1(_xhr.statusText);
      };
    });
  };
    
  //////////////////////////////////////////////////////////////////////// for local storage

  static myLS_clr() { // clear : remove all items.
    return new Promise( _o_end1 => {
      AsyncStorage.clear(()=>{
        _o_end1();
      });
    });
  }    

  static myLS_chk() { // asyncstorage ( = cookie を利用可能かの確認 )
    return new Promise( _o_end1 => {
      const _key = 'CheckAsyncStorage';
      const _val = 'Enabled'
      cf.myLS_set(_key, _val)
      .then( _b_res => {
        if ( _b_res == true ) {
          cf.myLS_get(_key)
          .then(_res => {
            if ( _res == _val ) {
              cf.myLS_rmv(_key)
              .then(() => {
                _o_end1(true);
              });
            }
            else {
              _o_end1(false);
            }
          });
        }
        else {
          _o_end1(false);
        };
      });
    });
  };

  static myLS_rmv(p_key) { // remove
    return new Promise( _o_end1 => {
      if (ic.gb_dbg) { // 開発
        AsyncStorage.removeItem(p_key)
        .then( () => {
          _o_end1();
        });
      }
      else { // 本番
        AsyncStorage.removeItem(bf.myCM_hash(p_key))
        .then( () => {
          _o_end1();
        });
      };
    });
  }    

  static myLS_get(p_key, pb_cpt=true) { // 値が存在しない場合は null、promise を用いた並列化を検討要
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.getItem(p_key)
        .then( _j => {
          _j = bf.j(_j);
          _o_end1(_j);
        })
        .catch( _err => {
          _o_end1(null);
        });
      }
      else { // 本番
        AsyncStorage.getItem(bf.myCM_hash(p_key))
        .then( async _j => {
          _j = await bf.myCM_cpt('d', _j, ic.g_srt_key);
          _j = bf.j(_j);
          _o_end1(_j);
        })
        .catch( _err => {
          _o_end1(null);
        });
      };
    })
  };

  static myLS_set(p_key, pa_val, pb_cpt=true) {
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.setItem(
          p_key, 
          bf.s(pa_val)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      }
      else { // 本番
        AsyncStorage.setItem(
          bf.myCM_hash(p_key), 
          bf.myCM_cpt('e', bf.s(pa_val), ic.g_srt_key)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      };
    });
  };

static myLS_loadStt(p_key, pa_inis=null) {
  return new Promise( _o_end1 => {
    let _key = bf.myCM_hash(p_key);
    AsyncStorage.getItem(_key)
    .then( async _s => {
      let _d_vals = bf.j(await bf.myCM_cpt('d', _s, ic.g_srt_key));
      global.c?.setState({
        [p_key]: _d_vals || pa_inis,
      }, () => {
        _o_end1(true);
      });
    })
    .catch( _err => {
      _o_end1(false);
    });
  });
};

static myLS_setStt = (p_sttName, pa_vals) => new Promise ( _o_end1 => {
  global.c?.setState({
    [p_sttName]: pa_vals,
  }, () => {
    cf.myLS_saveStt(p_sttName)
    .then(() => {
      _o_end1();
    });
  })
});

static myLS_saveStt(p_key) {
  return new Promise( async _o_end1 => {
    let _key = bf.myCM_hash(p_key)
    let _val = await bf.myCM_cpt('e', bf.s(global.c?.state[p_key] || {}), ic.g_srt_key)
//bf.l('1159:{}, {}'.f(_key, _val))
    AsyncStorage.setItem(
      _key, 
      _val
    )
    .then(() => {
//      AsyncStorage.getItem(
//        bf.myCM_hash(p_key)
//      )
//      .then( _s => {
//bf.l('1166:{}'.f(_s))
        _o_end1(true);
//      })
    })
    .catch( _err => {
      _o_end1(false);
    });
  });
};

    //////////////////////////////////////////////////////////////////////// for file-system

  static myFS_get_rootFdr() {
    return FileSystem.documentDirectory + 'downloads/';
  };                                    

  static myFS_make_fdr(p_fdr) { // make folder
    return new Promise((resolve, reject)=>{
      FileSystem.readDirectoryAsync(p_fdr)
      .catch((_err)=>{ // フォルダが存在しなかった場合
        FileSystem.makeDirectoryAsync(p_fdr);
      })
      resolve();
    });
  };

  static async myFS_open_url(p_url, p_name){ // not support web
    FileSystem.downloadAsync(p_url, p_name)
    .then((_d_ress) => { // 
      FileSystem.getContentUriAsync(_d_ress.uri)
      .then((_chgUri) => {
        if (cf.myRN_chk_os('a')) {
          IntentLauncher.startActivityAsync('android.intent.action.VIEW', { data: _chgUri, flags: 1, })
          .then((_res) => {
            alert('1266:'+bf.s(_res));
          })
          .catch((_err) => {
            alert('1269:'+bf.s(_err));
          });
        };
        if (cf.myRN_chk_os('i')) {
          Sharing.shareAsync(_chgUri)
        };
      })
      .catch((_err)=>{ // IntentLauncher.startActivityAsync がファイルから起動するアプリを識別できない場合は、このエラーが発生するもよう
        alert('1274:'+bf.s(_err));
      });
    })
    .catch((_err) => { // error ハンドリングは未整備
      alert('1278:{}, {}, {}'.f(p_url, p_name, _err));
    });
  };

  static myFS_pck_file() { // file picker
    return new Promise((resolve, reject) => {
      DocumentPicker.getDocumentAsync({
        multiple: true,
        copyToCacheDirectory: false, 
      })
      .then(async (_d_files)=>{
        if (_d_files.type == 'success') {
          _d_files.lct = 'int'
          resolve(_d_files);
        }
        else {
          reject();
        };
      });
    });
  };

  //////////////////////////////////////////////////////////////////////// for image-picker

  static async myIP_chk_pms(p_msg) {
    if (Constants.platform.ios) {
      const { status } = await ImagePicker.requestCameraRollPermissionsAsync(Permissions.CAMERA_ROLL); // 変数名 status を変更してはいけないもよう
      if ( status !== 'granted') {
        Alert.alert(p_msg);
      }
    }
  };

  static async myIP_pick_img(po_fnc, p_type) {
    //
    if (p_type == 'all') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.All,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'image') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'video') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Videos,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    };
  };

  //////////////////////////////////////////////////////////////////////// for keyevent, expo ng

  /*
  installation

  npm install react-native-keyevent --save
  react-native link react-native-keyevent

  vi ./android/app/src/main/java/com/atis/MainActivity.java

  import android.view.KeyEvent; // <--- import
  import com.github.kevinejohn.keyevent.KeyEventModule; // <--- import
  public class MainActivity extends ReactActivity {
    @Override  // <--- Add this method if you want to react to keyDown
    public boolean onKeyDown(int keyCode, KeyEvent event) {
      KeyEventModule.getInstance().onKeyDownEvent(keyCode, event);
      super.onKeyDown(keyCode, event);
      return true;
    }
    @Override  // <--- Add this method if you want to react to keyUp
    public boolean onKeyUp(int keyCode, KeyEvent event) {
      KeyEventModule.getInstance().onKeyUpEvent(keyCode, event);
    @Override
    public boolean onKeyMultiple(int keyCode, int repeatCount, KeyEvent event) {
        KeyEventModule.getInstance().onKeyMultipleEvent(keyCode, repeatCount, event);
        return super.onKeyMultiple(keyCode, repeatCount, event);
    }
    @Override
    protected String getMainComponentName() {
      return "ATIS";
    }
  }
  */    

  static myKY_stt_downEvt(po_fnc) {
    KeyEvent.onKeyDownListener( _evt => {
      po_fnc(_evt.pressedKey);
    });
  };

  static myKY_end_downEvt() {
    KeyEvent.removeKeyDownListener();
  };

  static myKY_stt_upEvt(po_fnc) {
    KeyEvent.onKeyUpListener( _evt => {
      po_fnc(_evt.pressedKey);
    });
  };

  static myKY_end_upEvt() {
    KeyEvent.removeKeyUpListener();
  };

  static myKY_stt_mplEvt(po_fnc) {
    KeyEvent.onKeyMultipleListener( _evt => {
      po_fnc(_evt.pressedKey);
    });
  };

  static myKY_end_mplEvt() {
    KeyEvent.removeKeyMultipleListener();
  };

//////////////////////////////////////////////////////////////////////// for react-navigation
static myNV_stt_move = (pd={ // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
  pageName: '',
  d_prms: {}
}) => new Promise( async _o_end1 => { // 子に渡す変数を pd_vals に指定
//bf.l('1592: here')
  if (pd.pageName != cf.myNV_get_name()) { // 異なる画面の場合のみ遷移
    let _o_this = global.c;
    global.c = null; // 遷移後の画面において、componentDidMount 前に、古い po_this が参照されることを防ぐ
    await _o_this.props.navigation.dispatch(
      CommonActions.reset({ // web の戻る操作を無効化（historyを毎回削除）
        index: 0,
        routes: [{
          name: pd.pageName,
          params: { prms: cf.myNV_cpt_prms(pd.d_prms) },
        }]
      })
    );
    _o_end1();
  }
  else {
    _o_end1();
  };
});

static myNV_end_move() { // 親からのpd_vals を返す
  return new Promise( _o_end1 => { // web で再描画することを考慮し _tmp を myLS_rmv しない
    let _r = cf.myNV_get_prms();
    _o_end1(_r);
  });
};

static myNV_cpt_prms = (pd) =>  {
  let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
  let _r = bf.s(pd);
  _r = bf.myCM_cpt('e', _r, _srt);
  _r = bf.myCM_cnv('ecdBase64', _r); // base64 に変換しないと通らない
  return _r
};

static myNV_get_prms = () => {
  let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
  let _r = (global.c?.props.route.params) ? global.c?.props.route.params['prms'] : null;
  _r = bf.myCM_cnv('dcdBase64', _r); // base64 に変換しないと通らない
  _r = bf.myCM_cpt('d', _r, _srt);
  _r = bf.j(_r);
//bf.l('1632: {}'.f(_r))
  return _r;
};

  static myNV_get_name() { // get current screen name
    if (bf.f(global.c?.props.route.name)) {
      return global.c?.props.route.name;
    }
    else {
      return null;
    }
  };

  //////////////////////////////////////////////////////////////////////// for react native
  static myRN_crt_stss(pd_vals1, pd_vals2=null) {
    if (bf.f(pd_vals2)){
      const _r = bf.myCM_upd(bf.myCM_upd(bf.myCM_upd(pd_vals1, pd_vals2), ic.gd_stss1), ic.gd_stss2);
      return _r;
    }
    else {
      const _r = bf.myCM_upd(bf.myCM_upd(pd_vals1, ic.gd_stss1), ic.gd_stss2);
      return _r;
    };
  };

  static myRN_chk_os(p_os) {
    let _r = false;
    if (Platform.OS == 'android' && p_os == 'a') {
      _r = true;
    };
    if (Platform.OS == 'ios' && p_os == 'i') {
      _r = true;
    };
    if (Platform.OS == 'web' && p_os == 'w') {
      _r = true;
    };
    return _r;
  };

  static myRN_chk_tkn(po_fnc1, po_fnc2) {
    if ( bf.f(global.c?.state.sgc_user_key) && bf.f(global.c?.state.sgc_tkn)) { // user_key および tkn が設定されている場合
      let _cnd1 = `"_KEY"={} AND "user3210"='{}'`.f(global.c?.state.sgc_user_key, global.c?.state.sgc_tkn);
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'user', 
        n_dms: 2, 
        cnd: _cnd1
      })
      .then( _d_users =>{
        if (bf.f(_d_users)) { // tkn が一致していた場合
          if (po_fnc1) {
            po_fnc1();
          };
        }
        else { // tkn が誤っていた場合
          if (po_fnc2) {
            po_fnc2();
          };
        };
      });
    }
    else { // user_key または tkn が設定されていない場合
      if (po_fnc2) {
        po_fnc2();
      };
    };
  };

  static myRN_cnv(p_mode, pa_val){
    if (p_mode == 'ecdBase64') { // encoded base64 日本語未対応？
//      return (pa_val) ? base64.encode(pa_val) : null;
      const Buffer = require("buffer").Buffer;
      return (pa_val) ? new Buffer(pa_val).toString('base64') : null;
    };

    if (p_mode == 'dcdBase64') { // decoded base64
//      return (pa_val) ? base64.decode(pa_val) : null;
      return (pa_val) ? base64.decode(pa_val) : null;
    };
  };

  static myRN_get_mimeType(p_file) {
    return mime.lookup(p_file);
  };

  static myRN_get_uri(p_str) {
    //
    if (!bf.f(p_str) || p_str.slice(0,1) != '{') {
      return null;
    };
    //
    return '{}/{}'.f(ic.g_url2, bf.p(p_str).file)
  };

/*
  static myRN_get_stss() { // get state // 永続化対象のみが対象
    return new Promise( async _o_end1 => {
      let _d_stss = {};
      for await (let [_key, _val] of bf.e(ic.gd_stss1)) {
        _d_stss[_key] = global.c?.state[_key];
      };
      _o_end1(_d_stss);
    });
  };
*/

  static myRN_ldr_show() { // show loader
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgcb_showLdr: true
      }, () =>{
        _o_end1();
      });
    });
  }

  static myRN_ldr_hide() { // hide loader
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgcb_showLdr:false
      }, () =>{
        _o_end1();
      });
    });
  }

  static myRN_mdl_show() { // show modal
    global.c?.setState({sgcb_showMdl:true});
  }

  static myRN_mdl_hide() { // show modal
    global.c?.setState({sgcb_showMdl:false});
  }

  static myRN_msg_get_grpKey(p_elm ,p_key){ // get message group Key
    return new Promise( _o_end1 => {
      let _cnd = bf.q('[ct21l11e]="{}" AND [ct21l11k]="{}"'.f(
        p_elm,
        p_key,
      ));
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'ct21', 
        n_dms: 2, 
        cnd: _cnd
      })
      .then( _d_ct21s => {
        if (bf.f(_d_ct21s)) { // メッセージグループが存在した場合
          _o_end1(_d_ct21s._KEY);
        }
        else { // メッセージグループが存在しなかった場合は追加
          let _d_vals = {
            ct21l11e: p_elm,
            ct21l11k: p_key,
            ct21c110: '',
            ct21cz10: '10',
          };
          cf.myCB_call_iud({
            ctr: 'ins', 
            elm: 'ct21', 
            d_vals: _d_vals
          })
          .then( _d_ct21s => {
            _o_end1(_d_ct21s._KEY);
          });
        };
      });
    });
  };

  static myRN_msg_cnv_msg(pld_ct20ss){ // get message
    return new Promise(async _o_end1 => {
      //
      let _r = [];
      let _dd_cashss = {};
      //
      for await (let [_idx, _d_ct20s] of bf.e(pld_ct20ss)) {
        //
        // 登録者情報の取得
        let _cnd2 = bf.q('[_KEY]={}'.f(_d_ct20s.ct20cy20))
        await cf.myCB_call_rfr(_d_ct20s, 'cm10', _cnd2, '', _dd_cashss)
        .then(async _d_ct20s => {
          //
          if (_d_ct20s.ct20c410 == '10'){ // メッセージの場合
            _r.push({
              type: 'msg',
              chb: false,
              key: '{_KEY}'.f2(_d_ct20s),
              name: '{cm10c310}'.f2(_d_ct20s),
              msg: '{ct20c610}'.f2(_d_ct20s),
              time: '{ct20cy10}'.f2(_d_ct20s),
              sort: '{ct20cy10}'.f2(_d_ct20s),
              vals: _d_ct20s,
            });
          };
          if (_d_ct20s.ct20c410 == '20'){ // ファイルの場合
            //
            // ファイル情報の取得
            let _cnd3 = bf.q('[ct10l11e]="ct20" AND [ct10l11k]="{}"'.f(_d_ct20s._KEY));
            await cf.myCB_call_rfr(_d_ct20s, 'ct10', _cnd3, '')
            .then( _d_ct20s => {
              //
              if (bf.f(_d_ct20s.ct10c610)) {
                _r.push({
                  type: 'file',
                  chb: false,
                  key: '{_KEY}'.f2(_d_ct20s),
                  name: '{cm10c310}'.f2(_d_ct20s),
                  file: {
                      name: bf.j('{ct10c610}'.f2(_d_ct20s)).name,
                      url: '{}/{}'.f(ic.g_url2,bf.j('{ct10c610}'.f2(_d_ct20s)).file),
                  },
                  time: '{ct20cy10}'.f2(_d_ct20s),
                  sort: '{ct20cy10}'.f2(_d_ct20s),
                  vals: _d_ct20s,
                });
              };
            });
          };
        })
      };
      _o_end1(_r);            
    });
  };

  static myRN_msg_upd_lastDtm(p_ct21Key, p_cm10Key){
    let _d_vals = {
      ct22b11k: p_ct21Key,
      ct22b21k: p_cm10Key,
      ct22cz10: '10',
      ct22i110: bf.myDT_get_now(),
    }
    let _cnd =  bf.q('[ct22b11k]="{}" AND [ct22b21k]="{}"'.f(
      p_ct21Key,
      p_cm10Key,
    ));
    cf.myCB_call_iud({
      ctr: 'ups', 
      elm: 'ct22', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      // 未読件数の初期化
      global.c?.setState({
          sgcn_msgCnt: 0,
      });
    })
  };

  static myRN_pll(plo_pmss) { // parallel
    return new Promise( _o_end1 => {
//      cf.myRN_ldr_show();
      Promise.all(plo_pmss)
      .then(async _lb_ress =>{
//        cf.myRN_ldr_hide(); 
        let _b = true;
        for await (let [_idx, _b_res] of bf.e(_lb_ress)){
          if (_b_res == false) { // 各 pms の戻り値に一つでも false が存在する場合は false を返す
            _b = false;
            break;
          };
        };
        _o_end1(_b); // myRN_ldr_hide の後に then した場合、正しく処理されない場合がある模様
      })
      .catch((_err) => {
        alert('1055:{}, {}'.f(_err, plo_pmss))
      })
    });
  };

  static myRN_load = (plo_pmss) => new Promise( _o_end1 => {
    cf.myRN_pll(plo_pmss)
    .then(()=>{
      _o_end1();
    });
  });

  static myRN_ins(po_pms) {
/*
    return po_pms
    .then( _d_is => {
      global.c?.upd();
    });
*/
    return po_pms
    .then( _b => {
      if ( _b != false ) {
/*
        cf.myRN_set_pageMode('edit')
        .then(()=>{
          global.c?.upd();
        });
*/
        global.c?.upd();
      }
      else {
//        cf.myRN_set_pageMode('edit');
      };
    });

  };

  static myRN_upd(plo_pmss) {
    cf.myRN_pll(plo_pmss)
    .then(()=>{
      cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
        _next[global.c?.state.sgc_pageName] = 'show';
      }))
      .then(()=>{
        global.c?.load();
      });
    });
  };

/*
  static myRN_move_fwd(pd={
    sgc_pageRole: '',
    sgc_pageName: '',
    sgc_pageMode: '',
  }) {
    new Promise( _o_end1 => {
      if (global.c?.onExit) { // 遷移前の画面の onLeave
        global.c?.onExit(pd)
        .then(() => {
          _o_end1();
        });
      }
      else {
        _o_end1();
      };
    })
    .then( () => {
      cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
        _next[pd.sgc_pageName] = pd.sgc_pageMode;
      }))
      .then(() => {
        cf.myNV_stt_move({
          pageName: pd.sgc_pageName,
          d_prms: {
            sgc_pageRole: pd.sgc_pageRole,
            sgc_pageName: pd.sgc_pageName,
            sgcn_pageTab: pd.sgcn_pageTab || 1,
          },
        })
      });
    });
  };
*/

  static myRN_move_fwd = (pd={
    sgc_pageRole: '',
    sgc_pageName: '',
    sgc_pageMode: '',
  }) => new Promise( _o_end1 => {
    new Promise( _o_end2 => {
      if (global.c?.onExit) { // 遷移前の画面の onLeave
        global.c?.onExit(pd)
        .then(() => {
          _o_end2();
        });
      }
      else {
        _o_end2();
      };
    })
    .then( () => {
      cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
        _next[pd.sgc_pageName] = pd.sgc_pageMode;
      }))
      .then(() => {
        cf.myNV_stt_move({
          pageName: pd.sgc_pageName,
          d_prms: {
            sgc_pageRole: pd.sgc_pageRole,
            sgc_pageName: pd.sgc_pageName,
            sgcn_pageTab: pd.sgcn_pageTab || 1,
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    });
  });

  static myRN_logout() {
    // LS の削除
    global.c?.setState({
      sgcd_pageCmns: {},
    }, () => {
      cf.myLS_clr() // global.c? が存在しなくとも実行
      .then(()=>{
/*
        // TOP 画面へ遷移
        cf.myNV_stt_move({ // global.c? を極力介さないため、myRN_move_fwd は使用しない
          pageName: ic.g_iniPageName,
          d_prms: {
            sgc_pageRole: ic.g_iniPageRole,
            sgc_pageMode: 'show',
          },
        });
*/
        cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
          _next[global.c?.state.sgc_pageName] = 'show';
        }))
        .then(() => {
          cf.myNV_stt_move({ // global.c? を極力介さないため、myRN_move_fwd は使用しない
            pageName: ic.g_iniPageName,
            d_prms: {
              sgc_pageName: ic.g_iniPageName,
              sgc_pageRole: ic.g_iniPageRole,
//              sgc_pageMode: 'show',
            },
          });
        });
      });
    })
  };

/*
  static myRN_clr_pageInf = () => new Promise( _o_end1 => {
bf.l('1798:{}'.f(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]))
    global.c?.setState({
      sgc_pageName: '',
      sgc_pageMode: '',
    }, ()=>{
bf.l('1802:{}'.f(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]))
      _o_end1();
    });
  });
*/

  static myRN_stt(po_this, po_fnc) { // この中では、global.c ではなく po_this を使用
    //
    if (!cf.myRN_chk_os('w')){ // version check
      cf.myCB_call_ver()
      .then((_d_ress)=>{
        if (_d_ress.result != ic.g_ver) { // バージョンをチェックし、最新化
          //alert('データを最新化するため、アプリを再起動します\n（複数回、行わなければならない場合があります）');
          //Updates.reloadAsync();
          alert('最新のプログラムをダウンロードください。');
        };
      })
      .catch((_err)=>{
        alert('1458:'+bf.s(_err));
      })
    };
    //
    Dimensions.addEventListener('change', () => {
      if(cf.myRN_chk_os('w')) {
        // location.reload(); // android で reload が発生？
      };
    });

    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
      //
      if (po_this.state.sgcd_inpMsrs.y == undefined) {
        return;
      };
      //
      let _dy = (po_this?.state.sgcd_inpMsrs.y + po_this?.state.sgcd_inpMsrs.h) - (ic.gn_h - _e.endCoordinates.height);
      //
      if (_dy <= 0) { // 下側が被った場合のみが対象
        _dy = 0;
      }
      //
      if (_dy >= _e.endCoordinates.height - ic.gn_bdyY) { // キーボード分のみが対象
        _dy = _e.endCoordinates.height - ic.gn_bdyY;
      }
      //
      //if (po_this?.state.sgcb_showMdl == false) { // mdl でない場合、移動
        //
        po_this.setState({
            sgcn_bdyY: ic.gn_bdyY - _dy - po_this?.state.sgcn_adjY,
        });
      //};
      //
    });
    //
    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
      //if (po_this?.state.sgcb_showMdl == false) { // 元の位置に戻す
        po_this.setState({
            sgcn_bdyY: ic.gn_bdyY,
        });
      //};
    });
    //
    po_this.focusListener = po_this.props.navigation.addListener("focus", () => { // 画面遷移時に再描画するために必要 2/4 po_this は旧・global.c は新であることに注意
      //
      global.c = po_this; // current component, defined at ic.js、move_bwd で切り替わることを考慮し willFocux の中で設定
      //
      cf.myNV_end_move()
      .then( _d_prms => {
//bf.l('2124:{}'.f(_d_prms))
//bf.l('1899:{}'.f(window.performance.navigation.type))
        po_this.setState(_d_prms, ()=>{ // この段階で、前コンポーネントからの情報が引き継がれる、global.c にした場合、move_bwd で実行されない模様
          //
          StatusBar.setHidden(true); // status bar を非表示
          //
          cf.myRN_pll([
            cf.myLS_loadStt('sgcd_pageCmns', {}),
            cf.myLS_loadStt('sgcd_pageModes', {}),
/*
            new Promise(_o_end1 => {
              cf.myLS_get('cm10_key')
              .then((_cm10_key) => {
                po_this.setState({
                  sgc_cm10_key: (_cm10_key) ? _cm10_key : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
*/
            new Promise(_o_end1 => {
              cf.myLS_get('tkn').then((_tkn) => {
                po_this.setState({
                  sgc_tkn: (_tkn) ? _tkn : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
            new Promise(_o_end1 => {
              cf.myLS_get('eml').then((_eml) => {
                po_this.setState({
                  sgc_eml: (_eml) ? _eml : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
          ])
          .then(()=>{
//bf.l('1977:{}'.f(global.c?.state.sgcd_pageModes));
            //
//            let _pageName = cf.myNV_get_name();
            let _pageName = po_this.props.route.name;// myNV_get_name は global.c を参照しているため使用しない
//bf.l('2168: {}'.f(_pageName))
            if (_pageName != ic.g_iniPageName &&
              bf.f(po_this.state.sgcd_pageCmns?.user_key)
            ) {
//bf.l('2173: {}'.f(_pageName))
              let _cnd = bf.q('[_KEY]={}'.f(
                po_this.state.sgcd_pageCmns?.user_key
              ));
              cf.myCB_call_slc({
                ctr: 'nlm', 
                elm: 'cm10', 
                n_dms: 2, 
                cnd: _cnd
              })
              .then( _d_cm10s => {
//bf.l('2016:{}'.f(_d_cm10s))
                if (bf.f(_d_cm10s)) {
                  cf.myRN_setCmns({
                      userb21k: _d_cm10s.cm10b21k,
                      userc410: _d_cm10s.cm10c410,
                      user_pfx: (_d_cm10s.cm10c330) ? _d_cm10s.cm10c330 : (_d_cm10s.cm10c310 || ''),
                  })
                  .then(()=>{
//bf.l('2193: {}'.f(_pageName))
                    if (po_fnc){
                      po_fnc();
                    };
                  });
                }
                else {
//bf.l('2199: {}'.f(_pageName))
                  cf.myRN_logout();
                }
              });
            }
            else{
//bf.l('2205: {}'.f(_pageName))
              if (_pageName == ic.g_iniPageName) {
                if (po_fnc){
//bf.l('2208: {}'.f(_pageName))
                  po_fnc();
                };
              }
              else {
//bf.l('2213: {}'.f(_pageName))
                cf.myRN_logout();
              }
            };
          })
        });
      });
    });
  };

  static myRN_end() {
    Dimensions.removeEventListener('change', () => {
    });
    global.c?.focusListener();
    global.c?.keyboardDidShowListener.remove();
    global.c?.keyboardDidHideListener.remove();
  };

  static myRN_open_url = (p_url) => new Promise( _o_end1 => {
    if (cf.myRN_chk_os('w') == true) {
      window.open(p_url, '_blank');
      _o_end1();
    }
    else {
      Linking.openURL(p_url);
      _o_end1();
    }
  });

  static myRN_setCmns(pd_is) { // set pageMode
    return new Promise( _o_end1 => {
      new Promise( _o_end2 => {
        if (!bf.f(global.c?.state.sgcd_pageCmns)) {
          global.c?.setState({
            sgcd_pageCmns: {
              d_pageModes: {},
            },
          }, () => {
            _o_end2();
          })
        }
        else {
          _o_end2();
        };
      })
      .then(() => {
        cf.myLS_setStt(
          'sgcd_pageCmns',
          bf.p(global.c?.state.sgcd_pageCmns, _next => {
            Object.keys(pd_is)
            .filter( _key => bf.f(_key) ? true : false)
            .map( _key => {
              _next[_key] = pd_is[_key];
            });
          })
        )
        .then(() => {
          _o_end1();
        })
      });
    })
  };

  static myRN_set_pageMode(p_pageMode) { // set pageMode
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgc_pageMode:p_pageMode,
      }, () => {
        _o_end1();
      });
    });
  };

  static myRN_user_ins(p_eml){
/*
    return new Promise ((_o_end1)=>{
      let _d_vals = {
        user1010: p_eml,
        user1020: bf.myCM_gnr(128),
        user1030: p_eml,
      }
      let _cnd = bf.q('[user1010]="{}"'.f(p_eml))
bf.l('2118:{}, {}'.f(_cnd, _d_vals))
      cf.myCB_call_iud({
        ctr: 'ups', 
        elm: 'user', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then((_d_users) => {
bf.l('2126:{}'.f(_d_users))
        let _d_vals2 = {
          cm10b11k: _d_users._KEY,
          cm10c110: '',
          cm10i110: p_eml,
        }
bf.l('2132:{}'.f(_d_vals2))
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'cm10', 
          d_vals: _d_vals2
        })
        .then((_d_cm10s) => {
bf.l('2139:{}'.f(_d_cm10s))
          _o_end1(_d_cm10s);
        });
      });
    });
*/
    return new Promise ((_o_end1)=>{
      new Promise( _o_end2 => {
        let _d_vals = {
          user1010: p_eml,
          user1020: bf.myCM_gnr(128),
          user1030: p_eml,
        }
        let _cnd = bf.q('[user1010]="{}"'.f(p_eml))
//bf.l('2154:{},{}'.f(_cnd, _d_vals));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'user', 
          cnd: _cnd,
          n_dms: 2,
        })
        .then( _d_is => {
//bf.l('2161:{}'.f(_d_is));
          if (bf.f(_d_is)) { // 登録済の場合
            _o_end2(_d_is._KEY);
          }
          else { // 未登録の場合
            cf.myCB_call_iud({
              ctr: 'ins', 
              elm: 'user', 
              d_vals: _d_vals, 
              cnd: _cnd
            })
            .then((_d_is) => {
              _o_end2(_d_is._KEY);
            });
          }
        })
      })
      .then( _key => {
//bf.l('2179:{}'.f(_key));
        let _d_vals = {
          cm10b11k: _key,
          cm10c110: '',
          cm10i110: p_eml,
        }
//bf.l('2185:{}'.f(_d_vals));
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'cm10', 
          d_vals: _d_vals
        })
        .then((_d_cm10s) => {
//bf.l('2193:{}'.f(_d_cm10s));
          _o_end1(_d_cm10s);
        });
      });
    });
  };

  static myRN_user_upd(p_user_key, p_eml){ // 自分自身の場合は、LS の変更も必要
    return new Promise ((resolve)=>{
      let _d_vals = {
        user1010: p_eml,
        user1030: p_eml,
      }
      let _cnd = bf.q('[_KEY]={}'.f(p_user_key))
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'user', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        resolve();
      });
    });
  }

  static myRN_prm_stt(p_id='0') { // promise initialize count
    global.c?.setState({
      sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
        _next[p_id] = 0;
      }),
    });
  };

  static myRN_prm_end(p_id='0') { // promise add count
    global.c?.setState({
      sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
        _next[p_id] += 1;
      }),
    });
  };

  static myRN_prm_wait(pn_maxCnt, p_id='0') { // promise add count
    //
    return new Promise( _o_end1 => {
      bf.myCM_clw(0.01, ()=>{
        if (global.c?.state.sgcd_prms[p_id] >= pn_maxCnt) {
          global.c?.setState({
            sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
              delete _next[p_id];
            }),
          });
          return true;
        }
        else {
          return false;
        };
      })
      .then(()=>{
        _o_end1();
      })
    });
  };

  //////////////////////////////////////////////////////////////////////// for message dialog
  static myWD_mdl(p_msg) {
    alert(p_msg,'');
  };

  static myWD_cdl(p_msg, po_fnc1, po_fnc2) {
    Alert.alert(p_msg, '', [{text:'はい', onPress:() => po_fnc1()}, {text:'いいえ', onPress:() => po_fnc2()}]);
  };

  //////////////////////////////////////////////////////////////////////// for websocket

  static myWS_gnr(p_url){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    return new WebSocket(p_url);
  };

  static myWS_onOpen(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onopen = () => {
      p_fnc();
    };
  };

  static myWS_onRcv(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onmessage = function (_msg) {
      p_fnc(_msg.data);
    };
  };

  static myWS_send_msg(p_ws, p_msg){ // 単発でイベントを発生
    p_ws.send(p_msg);
  };

  static myWS_close(p_ws){ // 単発でイベントを発生
    p_ws.close();
  };

};
